import { AdvancedAbortController, CancellablePromise, IsAdvancedAbortSignal, NormalizeICancellablePromiseOptions } from '@lifaon/observables';
import { FreezeObjectProperties } from '../../misc/helpers/object/freeze-property';
export function NormalizeIResolvableTreeResolveCallbackOptionsSignal(signal) {
    if (signal === void 0) {
        return new AdvancedAbortController().signal;
    }
    else if (IsAdvancedAbortSignal(signal)) {
        return signal;
    }
    else {
        throw new TypeError(`Expected void or AdvancedAbortSignal as signal`);
    }
}
export function NormalizeIResolvableTreeResolveCallbackOptionsStrategy(strategy) {
    if (strategy === void 0) {
        return 'never';
    }
    else if (['never', 'resolve', 'reject'].includes(strategy)) {
        return strategy;
    }
    else {
        throw new TypeError(`Expected void, 'never', 'resolve' or 'reject' as strategy`);
    }
}
export function NormalizeIResolvableTreeResolveCallbackOptions(options) {
    return FreezeObjectProperties(NormalizeICancellablePromiseOptions(options), ['signal', 'strategy']);
}
export function ResolveResolvableTreesOneByOne(trees, options) {
    return trees.reduce((promise, tree) => {
        return promise.then((path) => {
            return (path.length === 0)
                ? tree.resolve(options)
                : path;
        });
    }, CancellablePromise.resolve([], options));
}
export function CreateResolvableTreeResolver(resolverOptions = {}) {
    const resolve = (resolverOptions.resolve === void 0)
        ? (options) => {
            return CancellablePromise.resolve({ resolved: true }, options);
        }
        : resolverOptions.resolve;
    const resolvePath = (resolverOptions.resolvePath === void 0)
        ? function (options, path) {
            const instance = this;
            return CancellablePromise.try(() => {
                return ((instance.children.length > 0) && (path.length === 0))
                    ? []
                    : [instance].concat(path);
            }, options);
        }
        : resolverOptions.resolvePath;
    return function (options) {
        const instance = this;
        const normalizedOptions = NormalizeIResolvableTreeResolveCallbackOptions(options);
        return resolve.call(instance, normalizedOptions)
            .then((result) => {
            if (result.resolved) {
                const childrenOptions = (result.childrenOptions === void 0)
                    ? normalizedOptions
                    : result.childrenOptions;
                return ResolveResolvableTreesOneByOne(instance.children, childrenOptions)
                    .then((path) => {
                    const resolvePathOptions = (result.resolvePathOptions === void 0)
                        ? normalizedOptions
                        : result.resolvePathOptions;
                    return resolvePath.call(instance, resolvePathOptions, path);
                });
            }
            else {
                return [];
            }
        });
    };
}
//# sourceMappingURL=functions.js.map